<template>
    <div class="body">
         <div class="top-box-top">
            <top />
        </div>
        <div class="bottom-box">
            <basecom />
            <div class="list">
            </div>
        </div>
    </div>
</template>

<script>
import basecom from "@/components/base.vue";
import top from "@/components/top";
export default {
    components: { basecom,top },
    mounted(){
    }
};
</script>
<style>
@import url('../assets/index.css');
</style>
